import type { Contribution } from '@optionway/models';

interface SelectedContributionStore {
  contribution?: Contribution;
}

export const useSelectedContributionStore = defineStore('selected-contribution', {
  state: (): SelectedContributionStore => ({
    contribution: undefined,
  }),
  getters: {
    // Asked of any ratio, so a card can qualify the option it renders and not only the chosen one.
    isTotalRatio(): (ratio?: number) => boolean {
      const totalContributionRatio = 1;
      return (ratio?: number) => ratio === totalContributionRatio;
    },
    isFullContribution(): boolean {
      return this.isTotalRatio(this.contribution?.ratio);
    },
  },
  actions: {
    select(contribution?: Contribution) {
      const previous = this.contribution;
      this.contribution = contribution;
      useGtmStore().trackContributionChange(previous, contribution);
    },
  },
});
